<form class="drop-padding" [formGroup]="formGroup" (ngSubmit)="create()">
  <mat-form-field appearance="outline">
    <mat-label>Артикул</mat-label>
    <input matInput formControlName="article" type="text" placeholder="Артикул" />
  </mat-form-field>
  <button mat-flat-button color="primary" [disabled]="loading">Сохранить</button>
</form>
